import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseSelect } from "./BaseSelect";
import { ListItemContent } from "../ListItemContent";
export const Select = (props) => {
    return (_jsx(BaseSelect, Object.assign({}, props, { renderListItemContent: (_a) => {
            var { isSelected, value } = _a, listItemContentProps = __rest(_a, ["isSelected", "value"]);
            return _jsx(ListItemContent, Object.assign({}, listItemContentProps));
        } })));
};
//# sourceMappingURL=Select.js.map